var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    { staticClass: "button primary new-event", on: { click: _vm.newEvent } },
    [_vm._v("\n\t" + _vm._s(_vm.$t("calendar", "+ New event")) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }